// extracted by mini-css-extract-plugin
export default {"container":"style_container__zkRkD","item":"style_item__KvkJz","text":"style_text__89BJj"};